export class NewsFeedRequestSerializer {
  constructor({ isin, offset, filterDate }) {
    this.offset = offset;
    this.locale = "en";
    this.limit = 100;
    this.category_theme = isin;

    const startDate =
      filterDate.startDate === "" ? new Date() : new Date(filterDate.startDate);
    this.start_date = new Date(
      Date.UTC(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate()
      )
    );

    const endDate =
      filterDate.endDate === "" ? new Date() : new Date(filterDate.endDate);
    this.end_date = new Date(
      Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
    );
  }

  getRequest = () => {
    return JSON.stringify(this);
  };
}
